import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { SCUIContent } from '../../../atomic/organisms';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { SCUIAutoCompleteInput, SCUIButton } from '../../../atomic/atoms';
import { SCUIBreadCrumb, SCUIGeneralDrawer, SCUIGeneralDrawerHeader } from '../../../atomic/molecules';
import {
    EmailTemplateBuilderServiceQuery,
    LocalizationManagementQuery,
    MasterDataQuery,
} from '../../../services/query';
import { Alert, Grid, Paper, Autocomplete, TextField, Box } from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SaveTemplateDrawer from './components/SaveTemplateDrawer';
import Swal from 'sweetalert2';
import { ETBCT, ETBCT_ADD_SUB } from '../emailTemplateBuilder.classes';
import { sectionTypes } from '../EmailTemplateBuilder.config';

function CreateTemplate() {
    const { t } = useTranslation();
    const [drawerAddOpen, setDrawerAddOpen] = useState(false);
    const [createDrawerOpen, setCreateDrawerOpen] = useState(false);
    const onDrawerAddClose = () => setDrawerAddOpen(false);
    const [findedSection, setFindedSection] = useState<any>();
    const [htmlContent, sethtmlContent] = useState<string>('');
    const [autocompleteData, setAutocompleteData] = useState<any>();
    const [sectionKeys, setsectionKeys] = useState<any>([]);
    const [languageList, setLanguageList] = useState<any>();
    const [selectedLanguage, setSelectedLanguage] = useState('tr-TR');
    const [countryList, setCountryList] = useState<any>();
    const [selectedCountry, setSelectedCountry] = useState('TR');
    const [selectedType, setSelectedType] = useState(2);

    useEffect(() => {
        GetLanguageList();
        GetCountryList();
    }, []);

    const GetLanguageList = async () => {
        LocalizationManagementQuery.CultureList().then((res: any) => {
            setLanguageList(res.data);
        });
    };

    const GetCountryList = async () => {
        MasterDataQuery.GetCountryList().then((res: any) => {
            let parseData = res.data.map((item: any) => {
                return {
                    id: item.countryId,
                    key: item.countryKey,
                    name: item.countryCode,
                    dropdownValueText: item.translatedCountryName,
                };
            });
            setCountryList(parseData);
        });
    };

    const selectionHandleChange = (newValue: any) => {
        setFindedSection(newValue);
    };

    const handleaddButton = () => {
        if (findedSection !== undefined) {
            setsectionKeys((prevsectionKeys: any) => [...prevsectionKeys, findedSection.key]);
            sethtmlContent(htmlContent + findedSection.content);
        } else {
            Swal.fire(t('emailTemplateBuilder.pleaseSelectSection'));
        }
    };

    useEffect(() => {}, [htmlContent]);

    const handleSearch = (text: any) => {
        let request = {
            type: selectedType,
            keyword: text,
            languageCode: selectedLanguage,
            countryCode: selectedCountry,
            take: 100,
            skip: 1,
        };
        EmailTemplateBuilderServiceQuery.GetSectionData(request).then((res: any) => {
            setAutocompleteData(res.data);
        });
    };

    return (
        <SCUIContent>
            <Box className={ETBCT.page}>
            <SCUIGeneralDrawer
                open={drawerAddOpen}
                width={'400px'}
                onClose={(_: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        onDrawerAddClose();
                    }
                }}
            >
                <SCUIGeneralDrawerHeader
                    header={t('emailTemplateBuilder.addSubsectionfromTemplate')}
                    onClose={onDrawerAddClose}
                />
                <Grid
                    className={ETBCT_ADD_SUB.drawerBody}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        padding: '16px 20px',
                    }}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Grid
                        className={ETBCT_ADD_SUB.fieldCountry}
                        style={{ marginBottom: '1rem' }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {countryList && countryList.length > 0 && (
                            <Autocomplete
                                className={ETBCT_ADD_SUB.autocompleteCountryRoot}
                                options={countryList}
                                getOptionLabel={(option: any) => option?.dropdownValueText || ''}
                                value={countryList?.find((item: any) => item?.name === selectedCountry) || null}
                                onChange={(_, newValue) => {
                                    setSelectedCountry(newValue?.name || 'TR');
                                    setFindedSection(undefined);
                                    setAutocompleteData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className={ETBCT_ADD_SUB.inputAutocompleteCountry}
                                        label={t('emailTemplateBuilder.selectCountryName')}
                                    />
                                )}
                                disablePortal
                                sx={{
                                    width: '100%',
                                    '& .MuiOutlinedInput-root': {
                                        height: '40px !important',
                                        minHeight: '40px !important',
                                        maxHeight: '40px !important',
                                        '&.Mui-focused, &.Mui-selected, &:hover': {
                                            height: '40px !important',
                                            minHeight: '40px !important',
                                            maxHeight: '40px !important',
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        height: '8px !important',
                                        minHeight: '8px !important',
                                        padding: '8px 14px !important',
                                    },
                                }}
                            />
                        )}
                    </Grid>
                    <Grid
                        className={ETBCT_ADD_SUB.fieldLanguage}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {languageList && languageList.length > 0 && (
                            <Autocomplete
                                className={ETBCT_ADD_SUB.autocompleteLanguageRoot}
                                options={languageList}
                                getOptionLabel={(option: any) => option.code}
                                value={languageList.find((item: any) => item.code === selectedLanguage) || null}
                                onChange={(_, newValue) => {
                                    setSelectedLanguage(newValue?.code || 'tr-TR');
                                    setFindedSection(undefined);
                                    setAutocompleteData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className={ETBCT_ADD_SUB.inputAutocompleteLanguage}
                                        label={t('emailTemplateBuilder.selectLanguage')}
                                    />
                                )}
                                disablePortal
                                sx={{
                                    width: '100%',
                                    '& .MuiOutlinedInput-root': {
                                        height: '40px !important',
                                        minHeight: '40px !important',
                                        maxHeight: '40px !important',
                                        '&.Mui-focused, &.Mui-selected, &:hover': {
                                            height: '40px !important',
                                            minHeight: '40px !important',
                                            maxHeight: '40px !important',
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        height: '8px !important',
                                        minHeight: '8px !important',
                                        padding: '8px 14px !important',
                                    },
                                }}
                            />
                        )}
                    </Grid>
                    <Grid
                        className={ETBCT_ADD_SUB.fieldSectionType}
                        style={{ marginTop: '1rem' }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Autocomplete
                            className={ETBCT_ADD_SUB.autocompleteSectionTypeRoot}
                            options={sectionTypes}
                            getOptionLabel={(option: any) => option.name}
                            value={sectionTypes.find((item: any) => item.id === selectedType) || null}
                            onChange={(_, newValue) => {
                                setSelectedType(newValue?.id || 2);
                                setFindedSection(undefined);
                                setAutocompleteData([]);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    className={ETBCT_ADD_SUB.inputAutocompleteSectionType}
                                    label={t('emailTemplateBuilder.sectionType')}
                                />
                            )}
                            disablePortal
                            sx={{
                                width: '100%',
                                '& .MuiOutlinedInput-root': {
                                    height: '40px !important',
                                    minHeight: '40px !important',
                                    maxHeight: '40px !important',
                                    '&.Mui-focused, &.Mui-selected, &:hover': {
                                        height: '40px !important',
                                        minHeight: '40px !important',
                                        maxHeight: '40px !important',
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    height: '8px !important',
                                    minHeight: '8px !important',
                                    padding: '8px 14px !important',
                                },
                            }}
                        />
                    </Grid>
                    <Grid
                        className={ETBCT_ADD_SUB.fieldSection}
                        style={{ margin: '2rem 0' }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Box className={ETBCT_ADD_SUB.sectionAutocompleteWrap}>
                        {
                            <SCUIAutoCompleteInput
                                list={autocompleteData || []}
                                onChange={(event: any, newValue: any) => {
                                    selectionHandleChange(newValue);
                                }}
                                onChangeTextField={(e: any) => {
                                    if (e.target.value.length > 2) {
                                        handleSearch(e.target.value);
                                    }
                                }}
                                multiple={false}
                                txtPlaceHolder={t('emailTemplateBuilder.addSubSection')}
                                searchValue="key"
                            />
                        }
                        </Box>
                    </Grid>
                    <Grid
                        className={ETBCT_ADD_SUB.actionsFooter}
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            width: 'calc(100% - 40px)',
                            marginBottom: '20px',
                        }}
                    >
                        <SCUIButton
                            className={ETBCT_ADD_SUB.inputButtonAdd}
                            text={t('general.add')}
                            type="primary"
                            sizeType="default"
                            buttonType="submit"
                            size={'s'}
                            fullwidth
                            onClick={() => handleaddButton()}
                        />
                    </Grid>
                </Grid>
            </SCUIGeneralDrawer>
            <SCUIGeneralDrawer
                open={createDrawerOpen}
                width={'400px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setCreateDrawerOpen(false);
                    }
                }}
            >
                <SaveTemplateDrawer sectionKeyList={sectionKeys} />
            </SCUIGeneralDrawer>
            <SCUIBreadCrumb
                dontShowHome={true}
                homeIconLink={'/home'}
                onlyTitle={t('emailTemplateBuilder.emailTemplateBuilder')}
                components={[
                    {
                        title: t('emailTemplateBuilder.templateBuilder'),
                        link: '/emailTemplateBuilder',
                    },
                    {
                        title: t('emailTemplateBuilder.createTemplate'),
                        link: '/emailTemplateBuilder/createTemplate',
                    },
                ]}
            />
            <Grid container spacing={3} className={ETBCT.mainGrid} style={{ padding: 10 }}>
                <Grid
                    className={ETBCT.alertWrap}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Alert severity="warning" style={{ fontSize: '15px' }}>
                        {t('emailTemplateBuilder.createTemplateInfoText')}
                    </Alert>
                </Grid>
                <Grid container className={ETBCT.actionsRow} size={{ xs: 12 }}>
                <Grid
                    size={{
                        xs: 6,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    }}
                >
                    <SCUIButton
                        className={ETBCT.inputButtonAddSection}
                        showStartIcon
                        startIcon={<AddCircleOutlineIcon style={{ color: 'white' }} />}
                        onClick={() => setDrawerAddOpen(true)}
                        type={'primary'}
                        sizeType={'fixed'}
                        size={'s'}
                        text={t('emailTemplateBuilder.createTemplate')}
                    ></SCUIButton>
                </Grid>
                <Grid
                    style={{ textAlign: 'end' }}
                    size={{
                        xs: 6,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    }}
                >
                    <SCUIButton
                        className={ETBCT.inputButtonSaveTemplate}
                        disabled={htmlContent.length == 0}
                        showStartIcon
                        startIcon={<BookmarkIcon style={{ color: 'white' }} />}
                        onClick={() => setCreateDrawerOpen(true)}
                        type={'primary'}
                        sizeType={'fixed'}
                        size={'s'}
                        text={t('emailTemplateBuilder.saveTemplate')}
                    ></SCUIButton>
                </Grid>
                </Grid>
            </Grid>
            {htmlContent && (
                <Paper
                    className={ETBCT.previewPaper}
                    style={{
                        boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
                        border: '1px solid lightgrey',
                    }}
                >
                    {parse(DOMPurify.sanitize(htmlContent))}
                </Paper>
            )}
            </Box>
        </SCUIContent>
    );
}

export default CreateTemplate;
